import { useCallback, useState } from 'react';

import { BILLING_CYCLE_MONTHLY, BILLING_CYCLE_YEARLY } from '../constants/payment';

const useBillingCycle = (cycle = BILLING_CYCLE_YEARLY) => {
  const [billingCycle, setBillingCycle] = useState(cycle);

  const handleChange = useCallback(
    (v) => {
      if (v === BILLING_CYCLE_YEARLY) {
        setBillingCycle(BILLING_CYCLE_YEARLY);
      }

      if (v === BILLING_CYCLE_MONTHLY) {
        setBillingCycle(BILLING_CYCLE_MONTHLY);
      }
    },
    [setBillingCycle],
  );

  return [billingCycle, handleChange];
};

export default useBillingCycle;
